import moment from 'moment';
import { IExam } from 'components/models';
import { Color } from '_helpers';

export const getExamTimesLeftSubStatus = (exam: IExam) => {
    const differenceDays = moment().diff(exam.statusChangeTime, 'days');
    const timesLeft = exam.statusChangeTime.fromNow(true);
    const subStatus = {
        color: statusColorMapper(differenceDays),
        text: timesLeft === 'день' ? '1 день' : timesLeft,
    };

    return subStatus;
};

const statusColorMapper = (differenceDays: number): Color => {
    if (differenceDays <= 7) return Color.Default;
    if (differenceDays > 7 && differenceDays <= 14) return Color.Orange;
    return Color.Red;
};
